import httpService from "../../../services/httpService";


export const searchTailStats = (data: any, currentPage: Number) => {
    return httpService.post(`/api/tail-stats?page=${currentPage}&size=${100}`, data);
}

export const getTailStatsDetails = (tailNumber: string) => {
    return httpService.get(`/api/tail-stats/${tailNumber}/`);
}

export const getServicesByAirport = () => {
    return httpService.get('/api/services-by-airport')
}

export const getServices = (data: any) => {
    return httpService.post('/api/services', data);
}

export const getRetainerServices = (data: any) => {
    return httpService.post('/api/retainer-services', data);
}

export const searchRetainerCustomers = (data: any, currentPage: Number) => {
    return httpService.post(`/api/customers/retainers?page=${currentPage}&size=${100}`, data);
} 

export const getTeamProductivityStats = (data: any) => {
    return httpService.post('/api/team-productivity', data)
}

export const getUsersProductivityStats = (data: any) => {
    return httpService.post('/api/users-productivity', data)
}

export const getUserProductivityStats = (id: number, data: any) => {
    return httpService.post(`/api/user-productivity/${id}/`, data)
}

export const generateServiceReport = (data: any) => {
    return httpService.post('/api/service-report', data)
}

export const generateRetainerServiceReport = (data: any) => {
    return httpService.post('/api/retainer-service-report', data)
}

export const exportJobsAsync = (data: any) => {
    return httpService.post(`/api/jobs/export/async`, data)
}

export const searchServiceActivities = (data: any, currentPage: Number) => {
    return httpService.post(`/api/service-activities?page=${currentPage}&size=${200}`, data);
}

export const searchRetainerServiceActivities = (data: any, currentPage: Number) => {
    return httpService.post(`/api/retainer-service-activities?page=${currentPage}&size=${200}`, data);
}

export const getCustomers = (request: any) => {
    return httpService.post('/api/customers', request);
}

export const getAirports = (request: any) => {
    return httpService.post('/api/airports', request);
}

export const getFbos = () => {
    return httpService.get(`/api/fbos`);
}

export const getCustomerTails = (data: any) => {
    return httpService.post('/api/customers/tails', data);
} 

export const updateCustomerTail = (id: number, data: any) => {
    return httpService.patch(`/api/customers/tails/${id}/`, data);
}

export const flightBasedCleaningUpdate = () => {
    return httpService.get('/api/flight-based-cleaning/update');
}

export const getCustomerTailStats = (data: any) => {
    return httpService.post('/api/customers/tails/stats', data);
}

export const searchFbos = (data: any) => {
    return httpService.post(`/api/fbo-search`, data);
}

export const getVendors = (data: any) => {
    return httpService.post('/api/vendors', data);
}